import './sass/app.scss';

const baseURL = import.meta.env.VITE_BASE_URL;
const recruitmentAdminUrl = import.meta.env.VITE_RECRUITMENT_ADMIN_URL;
const jobsUrl = import.meta.env.VITE_JOBS_URL;
import Splide from "@splidejs/splide"

export class JobsWidget {
    constructor(obj = {}) {
        this.id = false
        this.defaults = {}

        Object.assign(this.defaults, {
            type: 'feed',
            limit: 1,
            url: location.href,
            locator: this.getCookie('vbd_locator') ? JSON.parse(this.getCookie('vbd_locator')) : false,
        }, obj)

        this.init()
    }

    elementBuilder(tag, att) {
        let container = document.createElement(tag)

        if (att.dataset) {
            for (let d in att.dataset) {
                container.dataset[d] = att.dataset[d]
            }
        }

        if (att.classes) container.classList.add(att.classes)
        if (att.href) container.href = att.href
        if (att.target) container.target = att.target
        if (att.html) container.innerHTML = att.html

        return container
    }

    isArray(a) {
        return Object.prototype.toString.call(a) === '[object Array]';
    }

    make(desc) {
        if (!this.isArray(desc)) {
            return make.call(this, Array.prototype.slice.call(arguments))
        }

        let name = desc[0]
        let attributes = desc[1]

        let el = document.createElement(name)

        let start = 1;

        if (typeof attributes === 'object' && attributes !== null && !this.isArray(attributes)) {

            for (let attr in attributes) {

                if (attr === 'dataset') {
                    for (let datasetKey in attributes[attr]) {
                        el.dataset[datasetKey] = attributes.dataset[datasetKey]
                    }
                } else {
                    el[attr] = attributes[attr]
                }
            }

            start = 2
        }

        for (let i = start; i < desc.length; i++) {
            this.isArray(desc[i]) ? el.appendChild(this.make(desc[i])) : el.appendChild(document.createTextNode(desc[i]))
        }

        return el
    }

    elements(json) {
        let wrapper = this.make(['div', {classList: 'feed-wrapper', dataset: {id: this.id}}])

        // Create the feed-container div outside the loop
        let splideSection = this.make([
            'section', {classList: 'splide'}, // Added parent div with class feed-container
        ]);

        let splideArrows = this.make([
            'div', {classList: 'splide__arrows'},
            ['button', {classList: 'splide__arrow splide__arrow--prev'}, ['img', {classList: '', src: baseURL + '/assets/images/arrow-backward.svg'}]],
            ['button', {classList: 'splide__arrow splide__arrow--next'}, ['img', {classList: '', src: baseURL + '/assets/images/arrow-forward.svg'}]],
        ]);

        let splideTrackHeader = this.make([
            'div', {classList: 'splide__track row'},
            [
                'div', {target: '_blank', classList: 'col header'},
                [
                    'div', {classList: 'feed-item'},
                    ['img', {classList: 'vettimes-logo', src: baseURL + '/assets/images/LogoBlack.svg'}],
                    ['h4', {classList: 'feed-heading'}, 'Jobs'],
                ],
                ['h4', {classList: 'feed-content'}, 'We connect you to the jobs that make your working life better.'],
                ['a', {classList: 'see-all-jobs', href: jobsUrl, target: '_blank'}, 'See all jobs']
            ],

        ]);

        let splideList = this.make([
            'ul', {classList: 'splide__list col'},
        ]);

        for (let index = 0; index < json.length; index++) {
            let i = json[index];
            let sal = false

            if (i.salary_pretty) {
                sal = i.salary_formatted
            }

            // Job Container only for desktop
            let desktopItem = this.make(
                [
                    'div', {classList: 'job-container desktop col'},
                    [
                        'a', {href: i.url, target: '_blank', dataset: {id: i.id}},
                        [
                            'div', {classList: 'feed-details'},
                            ['p', {classList: 'feed-title'}, i.title],
                            ['p', {classList: 'feed-salary'}, i.salary_formatted],
                            ['p', {classList: 'feed-recruiter'}, i.employer.title],
                            ['p', {classList: 'feed-location'},
                                ['img', {classList: 'location', src: baseURL + '/assets/images/location.svg'}],
                                ['span', {classList: 'feed-location-text'}, i.location_formatted],
                            ],
                            ['div', {classList: 'view-job'}, 'View job']
                        ]
                    ],
                ],
            );

            // Job Container only for mobile
            let item = this.make(
                [
                    'div', {classList: 'splide__slide'},
                    [
                        'div', {classList: 'job-container mob col'},
                        [
                            'a', {href: i.url, target: '_blank', dataset: {id: i.id}, classList: 'active'},
                            [
                                'div', {classList: 'feed-details'},
                                ['p', {classList: 'feed-title'}, i.title],
                                ['p', {classList: 'feed-salary'}, i.salary_formatted],
                                ['p', {classList: 'feed-recruiter'}, i.employer.title],
                                ['p', {classList: 'feed-location'},
                                    ['img', {classList: 'location', src: baseURL + '/assets/images/location.svg'}],
                                    ['span', {classList: 'feed-location-text'}, i.location_formatted],
                                ],
                                ['div', {classList: 'view-job'}, 'View job']
                            ]
                        ],
                    ],
                ],
            );

            item.addEventListener('click', (e) => {
                let closest = e.target.closest('.feed-container a')
                this.track(closest.dataset.id)
            })

            // Append each item to the feedContainer
            splideTrackHeader.appendChild(desktopItem)
            splideList.appendChild(item);
        }


        splideTrackHeader.appendChild(splideList)
        splideSection.appendChild(splideTrackHeader);
        splideSection.appendChild(splideArrows);

        // Add the feedContainer to the wrapper
        wrapper.appendChild(splideSection);

        return wrapper
    }

    until(conditionFunction, key) {
        const poll = resolve => {
            conditionFunction() ? resolve(this[key]) : setTimeout(_ => poll(resolve), 400)
        }

        return new Promise(poll)
    }

    async getJson() {
        return await this.until(_ => typeof this.items === 'object', 'items')
    }

    async courier(path, obj) {
        return await fetch(recruitmentAdminUrl + '/api/widgets/' + path, {
            method: 'post',
            body: JSON.stringify(obj),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
        })
    }

    track(id = false) {
        this.courier('track', {id: id, url: location.href, userdata: this.defaults.userdata})
    }

    mount(el) {
        this.getJson().then(json => {

            if (json.length) {

                let parent = document.querySelector(el)
                parent.classList.add('feed-parent')

                if (this.defaults.type === 'feed') {

                    let madgexLogo = this.make([
                        'a', {classList: 'feed-madgex', href: jobsUrl, target: '_blank'},
                        ['img', {classList: 'feed-madgex-logo', src: jobsUrl + '/assets/dist/images/logo.png'}, ''],
                    ])

                    parent.appendChild(madgexLogo)
                }

                parent.appendChild(this.elements(json))


                const splide = new Splide('.splide', {
                    perPage: 1,
                    gap: '2rem',
                    breakpoints: {
                        640: {
                            perPage: 2,
                            gap: '.7rem',
                            height: '6rem',
                        },
                        480: {
                            perPage: 1,
                            gap: '.7rem',
                            height: '6rem',
                        },
                    },
                });

                splide.mount()

                if (json.length <= 1) {
                    splide.options = { pagination: false, arrows: false };
                    splide.refresh();
                }

            }
        })

    }

    setCookie(name, value, days) {
        let setDate = new Date()
        setDate.setTime(setDate.getTime() + (days * 24 * 60 * 60 * 1000))
        let expires = '; expires=' + setDate.toGMTString()
        document.cookie = name + '=' + value + expires + '; path=/'
    }

    getCookie(name) {
        let nameEQ = name + "=";
        let ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    init() {
        this.courier('render', this.defaults).then(res => res.json()).then(json => {
            this.id = json.id
            this.items = json.feed

            if ('locator' in json) {
                this.setCookie('vbd_locator', JSON.stringify(json.locator), 7)
            }
        })
    }

}